<template>
    <div></div>
</template>

<script>
    import {HTTP} from "../http/http-common";

    export default {
        name: "vLogout",
        beforeMount() {
            /*
             * Revoke server-side first so the old bearer token stops working
             * even if it was captured; then clear sessionStorage — which is
             * where the token actually lives (this used to clear
             * localStorage, so logging out left a working session behind).
             */
            HTTP.post('api/logout')
                .catch(() => { /* clear the client session regardless */ })
                .then(() => {
                    window.sessionStorage.removeItem('userName');
                    window.sessionStorage.removeItem('token');
                    this.$store.commit('SET_USER_NAME', '');
                    this.$router.push('/login');
                });
        }
    }
</script>

<style scoped>

</style>
